import React, { useEffect, useState } from "react";
import { Col, Row, Card, Button, Checkbox, Form, Input, Select } from "antd";
import { LockOutlined, UserOutlined, EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useAuth from "../../hooks/useAuth";
import { getOrganisationDetails } from "../../features/organisations/organisationsSlice";

export default function Login() {
    const [isEmail, setIsEmail] = React.useState(true);
    const [showPassword, setShowPassword] = React.useState(false);
    const [organisation, setOrganisation] = useState(null);
    const { isLoading, error, auth } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!organisation) {
            getOrganisationDetails().then((org) => {
                setOrganisation(org);
            });
        }
    }, [organisation]);

    const handleUsernameChange = (e) => {
        const username = e.target.value;
        const emailRegex = /\S+@\S+\.\S+/;
        setIsEmail(emailRegex.test(username));
    };

    const onLogin = async (values) => {
        try {
            const slug = values.organisation || organisation.slug;
            const identifier = isEmail ? values.identifier : `${slug}-${values.identifier}`;
            const error = await auth.login({ ...values, identifier });
            if (!error) {
                navigate("/");
                window.location.reload();
            }
        } catch (error) {
            console.error("Login failed:", error);
            toast("Login failed", { type: "error" });
        }
    };

    useEffect(() => {
        if (auth.isLoggedIn()) {
            navigate("/");
        }
    }, [auth, navigate, organisation]);

    const allowedOtherTenants = organisation?.allowOtherTenants?.data?.length;

    const getItems = () => {
        const items = [{
            id: organisation.id,
            name: organisation.name,
            value: organisation.slug,
        }];
        if (allowedOtherTenants) {
            const otherTenants = organisation.allowOtherTenants.data;
            otherTenants.forEach(tenant => {
                items.push({
                    id: tenant.id,
                    name: tenant.attributes.name,
                    value: tenant.attributes.slug,
                })
            })
        }
        return items;
    };

    return (
        <div className="Login">
            <div className="AppContainer">
                <Row justify="center" align="middle">
                    <Col xs={24} md={14} lg={10}>
                        {auth.isLoggedIn() ? (
                            <Card>
                                <h1 className="SectionTitle">You are already logged in!</h1>
                            </Card>
                        ) : (
                            <Card>
                                <h1 className="SectionTitle">Login</h1>
                                <Form
                                    name="normal_login"
                                    className="login-form"
                                    initialValues={{
                                        remember: true,
                                    }}
                                    onFinish={onLogin}
                                    size="large"
                                >
                                    {allowedOtherTenants ? (
                                        <Form.Item
                                            name="organisation"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Please input your Organisation!",
                                                },
                                            ]}
                                            // initialValue={organisation.slug}
                                        >
                                            <Select placeholder="Select Organisation">
                                                {getItems()?.map((item) => (
                                                    <Select.Option key={item.value} value={item.value}>
                                                        {item.name}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    ): ""}
                                    <Form.Item
                                        name="identifier"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Please input your Username!",
                                            },
                                        ]}
                                    >
                                        <Input
                                            prefix={<UserOutlined className="site-form-item-icon" />}
                                            placeholder="Username"
                                            onChange={handleUsernameChange}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="password"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Please input your Password!",
                                            },
                                        ]}
                                    >
                                        <Input
                                            prefix={<LockOutlined className="site-form-item-icon" />}
                                            type={showPassword ? "text" : "password"}
                                            placeholder="Password"
                                        />
                                    </Form.Item>
                                    <div style={{ padding: "15px" }} onClick={() => setShowPassword(!showPassword)}>
                                        {showPassword ? (
                                            <EyeOutlined className="site-form-item-icon" />
                                        ) : (
                                            <EyeInvisibleOutlined className="site-form-item-icon" />
                                        )}
                                    </div>
                                    <Form.Item>
                                        <Form.Item name="remember" valuePropName="checked" noStyle>
                                            <Checkbox>Remember me</Checkbox>
                                        </Form.Item>

                                        <a className="login-form-forgot" href="/forgot-password">
                                            Forgot Password
                                        </a>
                                    </Form.Item>
                                    {error && <div className="error">{error}</div>}
                                    <Form.Item>
                                        <Button type="primary" htmlType="submit" className="login-form-button" loading={isLoading}>
                                            Log in
                                        </Button>
                                    </Form.Item>
                                    <Form.Item>
                                        <div style={{ textAlign: "center", width: "100%" }}>
                                            <a href="/register">Register Now!</a>
                                        </div>
                                    </Form.Item>
                                </Form>
                            </Card>
                        )}
                    </Col>
                </Row>
            </div>
        </div>
    );
}
